module.exports = __webpack_public_path__ + "img/KI logo.c3ba87b7.svg";